<template>
  <div class="bg-white min-h-screen px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
    <div class="max-w-max mx-auto">
      <main class="sm:flex">
        <p class="text-4xl font-extrabold text-primary sm:text-5xl">404</p>
        <div class="sm:ml-6">
          <div class="sm:border-l sm:border-gray-200 sm:pl-6">
            <h1 class="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">Страница не найдена</h1>
            <p class="mt-1 text-base text-gray-500">Убедитесь, что вы перешли по ссылке из уведомления.</p>
          </div>
          <div class="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
            <a href="https://my.zenky.io/dashboard" class="text-base font-medium text-primary hover:underline">
              Перейти в панель управления<span aria-hidden="true"> &rarr;</span>
            </a>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
export default {}
</script>
